import { register, type RegisteredComponent } from '@builder.io/sdk-angular';
import { LeadMagnetBuilderIoActiveCampaignComponent } from '@features/lead-magnet/components/lead-magnet-builder-io-active-campaign/lead-magnet-builder-io-active-campaign.component';
import { TrustpilotMicroComboBadgeComponent } from '@shared/trustpilot-micro-combo-badge/trustpilot-micro-combo-badge.component';

export const customBuilderIOComponents: RegisteredComponent[] = [
    {
        component: TrustpilotMicroComboBadgeComponent,
        name: 'TrustpilotMicroComboBadgeComponent',
        meta: {
            selector: 'app-trustpilot-micro-combo-badge',
            standalone: true,
        },
        inputs: [
            {
                name: 'isGrayscale',
                type: 'boolean',
                defaultValue: false,
            },
            {
                name: 'theme',
                type: 'string',
                defaultValue: 'dark',
            },
        ],
    },
    {
        component: LeadMagnetBuilderIoActiveCampaignComponent,
        name: 'ActiveCampaignLeadMagnet',
        meta: {
            selector: 'app-lead-magnet-builder-io-active-campaign',
            standalone: true,
        },
        inputs: [
            {
                name: 'id',
                type: 'string',
                required: true,
                description: 'id defined in contentful',
            },
        ],
    },
];

register('editor.settings', {
    designTokens: {
        colors: [
            { name: 'FA Red', value: 'rgb(238 87 105)' },
            { name: 'FA Secondary teal', value: '#488A87' },
            { name: 'Default text colour', value: '#424242' },
        ],
        borderRadius: [
            { name: 'None', value: '0px' },
            { name: 'Standard', value: '0.75rem' },
            { name: 'Standard bottom', value: '0 0 0.75rem 0.75rem' },
            { name: 'Standard top', value: '0.75rem 0.75rem 0 0' },
            { name: 'Circle', value: '50%' },
            { name: 'Large', value: '2rem' },
        ],
        fontSize: [
            { name: 'Extra Small', value: '0.75rem' },
            {
                name: 'Small',
                value: '0.875rem',
            },
            {
                name: 'Default',
                value: '1rem',
            },
            { name: 'Large', value: '1.125rem' },
            { name: 'Extra Large', value: '1.25rem' },
        ],
        spacing: [
            { name: 'None', value: '0' },
            { name: 'Tiny', value: '0.25rem' },
            { name: 'Small', value: '0.5rem' },
            { name: 'Large', value: '1rem' },
            { name: 'Extra Large', value: '2rem' },
            { name: 'Extra Extra Large', value: '4rem' },
        ],
    },
});
